import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import SidebarPageLayout from '../../components/layout/SidebarPageLayout';
import Breadcrumbs from '../../components/layout/Breadcrumbs';
import { apiFetch } from '../../api/apiClient';

function Roles() {
  const [roles, setRoles] = useState([]);
  const [loadError, setLoadError] = useState('');

  useEffect(() => {
    document.title = 'Vivosol Plant Performance Insights Hub | Help / Documentation / Roles';
  }, []);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        const data = await apiFetch('/api/documentation');
        const nextRoles = Array.isArray(data?.roles) ? data.roles : [];
        if (!cancelled) {
          setRoles(nextRoles);
          setLoadError('');
        }
      } catch (apiError) {
        console.warn('API fetch failed for /api/documentation:', apiError);
        if (!cancelled) {
          setRoles([]);
          setLoadError('Unable to load roles.');
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <SidebarPageLayout id="documentation-roles">
      <div className="content p-5">
        <h1 className="mb-0">Roles</h1>
        <Breadcrumbs />
        {loadError ? <p className="text-muted mb-0">{loadError}</p> : null}
        <div className="roles">
          {roles.map((role) => (
            <section id={role.slug || String(role.role_id)} key={role.role_id} className="role">
              <h2>{role.label}</h2>
              {role.description ? <p>{role.description}</p> : null}
            </section>
          ))}
        </div>
      </div>
    </SidebarPageLayout>
  );
}

export default Roles;
